RivalIQ.apps.SocialChannelMatrix.module('enums', function (enums, App, Backbone, Marionette, $, _, CompareData) {

    'use strict';

    const cd = RivalIQ.utils.companyDisplay;
    const compareData = new CompareData();

    enums.Channel = {};

    /**
     * This helps remove some of the boilerplate. It's used to build up the array of options for each channel
     * @param {CompareData.sources} compareDataSource
     * @param {CompareData.metrics} audienceMetric
     * @param {String} profilePicDimension
     * @param {Function} getChannelRecord
     * @param {Function} getChannelNativelink
     * @param {String} changeRequestPrompt
     * @param {Function} [getChannelDecoratedHandle]
     */
    function addChannel(compareDataSource, audienceMetric, profilePicDimension, getChannelRecord,
        getChannelNativelink, changeRequestPrompt, getChannelDecoratedHandle) {
        enums.Channel[CompareData.sourceDetails[compareDataSource].channel] = {
            name: CompareData.sourceDetails[compareDataSource].name,
            getChannelRecord: getChannelRecord,
            getChannelNativeLink: getChannelNativelink,
            getChannelDecoratedHandle: getChannelDecoratedHandle,
            needsReviewKey: CompareData.sourceDetails[compareDataSource].channel,
            suggestEditKey: CompareData.sourceDetails[compareDataSource].channel,
            discoveryKey: CompareData.sourceDetails[compareDataSource].channel,
            matrixListRowUIKey: CompareData.sourceDetails[compareDataSource].channel,
            audienceMetricKey: 'presence_reach',
            audienceMetricLabel: compareData.getMetricAbbreviatedName(audienceMetric),
            profilePicDimension: profilePicDimension,
            fontIcon: CompareData.sourceDetails[compareDataSource].fontIcon,
            changeRequestPrompt: changeRequestPrompt,
            source: compareDataSource
        };
    }

    addChannel(
        CompareData.sources.TWITTER,
        CompareData.metrics.TWITTER_FOLLOWERS,
        '48px',
        cd.getPrimaryTwitterRecord,
        cd.getTwitterLink,
        'e.g. https://twitter.com/rivaliq',
        cd.getTwitterDecoratedHandle
    );
    addChannel(
        CompareData.sources.FACEBOOK,
        CompareData.metrics.FACEBOOK_LIKES,
        '50px',
        cd.getPrimaryFacebookRecord,
        cd.getFacebookLink,
        'e.g. https://facebook.com/rivaliq',
        cd.getFacebookDecoratedHandle
    );
    addChannel(
        CompareData.sources.YOUTUBE,
        CompareData.metrics.YOUTUBE_SUBSCRIBERS,
        '50px',
        cd.getPrimaryYouTubeRecord,
        cd.getYouTubeLink,
        'e.g. https://youtube.com/user/rivaliq'
    );
    addChannel(
        CompareData.sources.INSTAGRAM,
        CompareData.metrics.INSTAGRAM_FOLLOWED_BY,
        '50px',
        cd.getPrimaryInstagramRecord,
        cd.getInstagramLink,
        'e.g. https://instagram.com/rival_iq',
        cd.getInstagramDecoratedHandle
    );
    addChannel(
        CompareData.sources.TIKTOK,
        CompareData.metrics.TIKTOK_FOLLOWERS,
        '50px',
        cd.getPrimaryTiktoktRecord,
        cd.getTiktokLink,
        'e.g. https://tiktok.com/@rivaliq/',
        cd.getTiktokDecoratedHandle
    );
}, RivalIQ.data.CompareData);
